import React, { useEffect, useState } from "react";
import { Col, Card, Badge } from "react-bootstrap";
import moment from "moment";
import axios from "axios";
import EmptyState from "./EmptyState";

const DataLeaksMessages = () => {
  const [messages, setMessages] = useState([]);
  const message_type = "Data leak";

  const fetchMessages = () => {
    axios
      .get(
        `${process.env.REACT_APP_EAS_BASE_URL}/api/messages/type/${message_type}`,
        {
          headers: {
            apikey: process.env.REACT_APP_EAS_API_KEY,
            "X-CloudManager-Id": process.env.REACT_APP_EAS_CLOUD_ID,
          },
        }
      )
      .then((response) => {
        setMessages(response.data);
      })
      .catch((error) => console.error("Failed to fetch messages: ", error));
  };

  useEffect(() => {
    fetchMessages();
  }, []);

  const hasData = messages?.length > 0;

  return (
    <Col md={4} className="mb-4">
      <Card style={{ minHeight: "360px" }}>
        <Card.Body className={hasData ? "scrollable-card-body" : ""}>
          <h6 className="fw-bold mb-2 text-muted">{`Latest Data Leaks`}</h6>
          {!hasData ? (
            <EmptyState title="No data leaks found" />
          ) : (
            messages.map((message, index) => (
              <Card key={index} className="mb-2">
                <Card.Body className="py-1">
                  <div className={"mb-2"}>
                    <div className="d-flex justify-content-between mb-2">
                      <span className="inline-block small">
                        <Badge bg="warning" style={{ fontSize: "10px" }}>
                          {message?.message_type}
                        </Badge>{" "}
                      </span>
                    </div>
                    {message?.author && (
                      <small className="d-block" style={{ fontSize: "12px" }}>
                        <span className="text-muted fw-semibold">
                          Threat Actor:
                        </span>{" "}
                        {message?.author}
                      </small>
                    )}
                    {message?.source && (
                      <small className="d-block" style={{ fontSize: "12px" }}>
                        <span className="text-muted fw-semibold">Source:</span>{" "}
                        {message?.source}
                      </small>
                    )}
                    {message?.content && (
                      <small className="d-block" style={{ fontSize: "12px" }}>
                        <span className="text-muted fw-semibold">Content:</span>{" "}
                        {message?.content}
                      </small>
                    )}
                    {message?.detection_date && (
                      <small className="d-block" style={{ fontSize: "12px" }}>
                        <span className="text-muted fw-semibold">
                          Intercepted on:
                        </span>{" "}
                        {moment(message?.detection_date).format(
                          "MMM Do YYYY, h:mm A"
                        )}{" "}
                        UTC
                      </small>
                    )}
                  </div>
                </Card.Body>
              </Card>
            ))
          )}
        </Card.Body>
      </Card>
    </Col>
  );
};

export default DataLeaksMessages;
